<div *ngrxLet="params$; let params"
     [formGroup]="editorFormGroup"
     class="min-w-[214px]"
     [style.width.px]="params?.eGridCell?.clientWidth + 2 > statusToggles.clientWidth ?
       params?.eGridCell?.clientWidth + 2 :
       statusToggles.clientWidth" cdkTrapFocus>
  <div id="statusToggles" #statusToggles >
    <mat-button-toggle-group formControlName="businessStatus">
      <mat-button-toggle #buttonToggle  value="CLOSED_PERMANENTLY">Permanently closed
      </mat-button-toggle>
      <mat-button-toggle  value="CLOSED_TEMPORARILY">Temporarily closed
      </mat-button-toggle>
      <mat-button-toggle  value="OPEN">Open</mat-button-toggle>
    </mat-button-toggle-group>
    <mat-button-toggle-group formControlName="managementStatus">
      <mat-button-toggle
          value="AUTOMATICALLY_MANAGED"

          [disabled]="editorFormGroup?.get(LSCField.managementStatus)?.value === 'MANUALLY_MANAGED'">
        Automatically managed
      </mat-button-toggle>
      <mat-button-toggle
          value="MANUALLY_MANAGED"

          [disabled]="editorFormGroup?.get(LSCField.managementStatus)?.value === 'AUTOMATICALLY_MANAGED'">
        Manually managed
      </mat-button-toggle>
      <mat-button-toggle
          value="NOT_MANAGED"
          >Not managed
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>
</div>
